import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import Card from '../../../components/Card'
import { Button, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { formatRupiah } from '../../../utilities/Utils'
import { FaEdit, FaTrash } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'

const ExpandableComponentNonLalinPeriksa = ({ data }) => {

    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listData, setListData] = useState([])
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!data) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const _resDtlPeriksa = await nonLalinService.listNonlalinDtlPeriksaAll(data.trNonlalinDtlPK.nomorAju, data.trNonlalinDtlPK.seri)
                // console.log(_resDtlPeriksa)
                setListData(_resDtlPeriksa.data.data)
            } catch (error) {
                setListData([])
            }
            setLoading(false)
        }
        fetchAllData()
    }, [nonLalinService, data])

    const columns = [
        {
            name: 'Seri Tarif',
            cell: row => row['trNonlalinDtlPeriksaPK'].seriTarif,
            grow: 0.1
        },
        {
            name: 'Jenis Pengujian',
            cell: row => row['nmTarif']
        },
        {
            name: 'Tarif',
            cell: row => formatRupiah(row['tarif'])
        },
        {
            name: 'Satuan',
            cell: row => row['satuan']
        },
        {
            name: 'Volume',
            cell: row => row['volume'],
            grow: 0.2
        },
        {
            name: 'Total Tarif',
            cell: row => formatRupiah(row['totalTarif'])
        },
        {
            name: 'Kesiapan Cek UPT',
            cell: row => row['isUptCanCheck'] === 'Y' ? <><span className='text-success'>Siap Diperiksa UPT</span></> : <><span className='text-danger'>Tidak Siap Diperiksa UPT</span></>
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        {localStorage.getItem('isEditStorage') === '1' ?
                            <div className='col-12 mb-1'>
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah</Tooltip>}>
                                    <Button size='sm' variant='warning'>
                                        <FaEdit />
                                    </Button>
                                </OverlayTrigger>{' '}
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus</Tooltip>}>
                                    <Button size='sm' variant='danger'>
                                        <FaTrash />
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div> : ''
                        }
                        {
                            localStorage.getItem('role') !== '4' && localStorage.getItem('role') !== '5' &&
                            <div className='col-12 mb-1'>
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Tidak Tersedia</Tooltip>}>
                                    <Button size='sm' variant='danger' onClick={() => handleShowConfirmNoReady(row)}>
                                        <FaTrash /> Tidak Tersedia
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        }
                    </div>
                </>
            )
        }
    ]

    const [dataDtlPeriksa, setDataDtlPeriksa] = useState(null)
    const [showConfirmNotReady, setShowConfirmNotReady] = useState(false)
    const handleCloseConfirmNotReady = () => setShowConfirmNotReady(false)
    const handleShowConfirmNoReady = (row) => {
        setDataDtlPeriksa(row)
        setShowConfirmNotReady(true)
    }
    const [loadingNotReady, setLoadingNotReady] = useState(false)
    const [showSaveNotReadySuccess, setShowSaveNotReadySuccess] = useState(false)
    const [showSaveNotReadyFailed, setShowSaveNotReadyFailed] = useState(false)

    const handleClickSaveNotReady = async () => {
        setLoadingNotReady(true)
        try {
            let jsonDtlPeriksa = {
                ...dataDtlPeriksa,
                isUptCanCheck: 'T'
            }
            const res = await nonLalinService.saveNonlalinDtlPeriksa(jsonDtlPeriksa)
            if (res.data.kode === '200') {
                setShowConfirmNotReady(false)
                setShowSaveNotReadySuccess(true)
            } else {
                setShowConfirmNotReady(false)
                setShowSaveNotReadyFailed(true)
            }
        } catch (error) {
            setShowConfirmNotReady(false)
            setShowSaveNotReadyFailed(true)
        }
        setLoadingNotReady(false)
    }

    const handleClickSaveNotReadySuccess = () => {
        setShowSaveNotReadySuccess(false)
    }

    const handleClickSaveNotReadyFailed = () => {
        setShowSaveNotReadyFailed(false)
    }

    return (
        <>
            <Card>
                <Card.Body>
                    {loading && <Spinner />}
                    <DataTable
                        customStyles={{ headCells: { style: { 'background-color': '#717475', 'color': 'white' } } }}
                        columns={columns}
                        data={listData}
                        persistTableHead={true}
                        highlightOnHover
                    />
                </Card.Body>
            </Card>
            {
                showConfirmNotReady &&
                <SweetAlert
                    title="Pengujian Tidak Siap Dilakukan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingNotReady ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSaveNotReady}
                    onCancel={handleCloseConfirmNotReady}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingNotReady}
                >
                    {loadingNotReady && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSaveNotReadySuccess &&
                <SweetAlert
                    success
                    title="Proses Berhasil Disimpan"
                    onConfirm={handleClickSaveNotReadySuccess}
                    btnSize="sm"
                />
            }
            {
                showSaveNotReadyFailed &&
                <SweetAlert
                    danger
                    title="Proses Gagal Disimpan"
                    onConfirm={handleClickSaveNotReadyFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ExpandableComponentNonLalinPeriksa